import React from 'react';

/**
 * Reusable avatar: shows profile image if URL provided, otherwise initial letter.
 * Used for navbar, profile cards, comments, posts, etc.
 */
const UserAvatar = ({
  src = null,
  name = '',
  size = 40,
  className = '',
  ...rest
}) => {
  const sizeClass = typeof size === 'number' ? { width: size, height: size, fontSize: size * 0.45 } : {};
  const initial = (name && name.charAt(0)) || '?';

  if (src && src.trim()) {
    return (
      <img
        src={src}
        alt={name || 'User'}
        className={`rounded-full object-cover flex-shrink-0 ${className}`}
        style={{ width: size, height: size, ...sizeClass }}
        {...rest}
      />
    );
  }

  return (
    <div
      className={`rounded-full flex items-center justify-center flex-shrink-0 bg-blue-500 text-white font-bold ${className}`}
      style={{ width: size, height: size, ...sizeClass }}
      {...rest}
    >
      {initial.toUpperCase()}
    </div>
  );
};

export default UserAvatar;
